import { Box } from "@mui/material";
import { CSSProperties } from "react";
import { EventProps } from "react-big-calendar";

import { clsxc } from "@/common/clsxc";

import { GenericCalendarEntry } from "../Calendar";

interface Props<TEntry extends GenericCalendarEntry> extends EventProps<TEntry> {
  className?: string;
  style?: CSSProperties;
}

/** This is not a replacement of the RBC event but it renders inside it:
 *  .rbc-event > .rbc-event-content > .event-custom */
export function RBCEventCustom<TEntry extends GenericCalendarEntry>(props: Props<TEntry>) {
  // console.log("RBCEventCustom", props);
  return (
    <Box component='div' className={clsxc(props.className, "rbc-event-custom")} style={props.style}>
      {props.title}
    </Box>
  );
}
